import { HttpService } from "@/core";
import { ExportReq, ExportResp } from "@/core/interface";
import { LogPageResp } from "@/views/work-manage/log/log.interface";

export class LogSelectService {
  static useSimplePageApi() {
    const api = (projectId?) =>
      HttpService.axios({
        method: "GET",
        url: "/project_work_log/projectWorkLogSimpleList",
        params: { projectId },
      });
    return HttpService.usePagination<LogPageResp>(api);
  }
}
